import { createSlice } from "@reduxjs/toolkit";

export const startUserGrantsFetch = (key) => {
    return {
        type: userGrantsFetchStarted.type,
        payload: { key },
    };
};

export const finishUserGrantsFetch = (key, grantedClaims) => {
    return {
        type: userGrantsFetchFinished.type,
        payload: { key, grantedClaims },
    };
};

//
//Store Slice Creator
//

// The signed-in user's granted claims for their active tenant/org/appspace
// selection, resolved by WithAuth (three bulk Access API calls) and read back
// as props.permissions on every wrapped component. Keyed by user + selection;
// stale-while-revalidate: verdictsKey tells which key the stored verdicts
// belong to, so a same-key revalidation keeps serving them until fresh ones
// land.
const slice = createSlice({
    name: "accessReducer",
    initialState: {
        // The key (user|tenant|org|appspace) of the most recently STARTED fetch.
        fetchKey: null,
        // The key the STORED verdicts belong to; trails fetchKey until the
        // fetch lands (stale-while-revalidate).
        verdictsKey: null,
        resolving: false,
        grantedClaims: [],
        resolvedAt: 0,
    },
    reducers: {
        // A fetch is underway for this user+selection key; existing verdicts
        // keep serving until it lands (stale-while-revalidate).
        userGrantsFetchStarted: (access, action) => {
            access.fetchKey = action.payload.key;
            access.resolving = true;
        },
        // The fetch for this key came back; store its verdicts. A fetch for a
        // key that is no longer current is discarded.
        userGrantsFetchFinished: (access, action) => {
            if (access.fetchKey === action.payload.key) {
                access.grantedClaims = action.payload.grantedClaims;
                access.verdictsKey = action.payload.key;
                access.resolvedAt = Date.now();
                access.resolving = false;
            }
        },
    },
});

export const { userGrantsFetchStarted, userGrantsFetchFinished } = slice.actions;

export default slice.reducer;
